import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import HoneycombLogo from './HoneycombLogo';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <HoneycombLogo size={36} />
                            <span className="logo-text">SkillHive</span>
                        </div>
                        <p className="footer-description">
                            Your trusted platform for growing your service business and connecting with customers.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Resources</h4>
                        <ul>
                            <li><Link to="/">Dashboard</Link></li>
                            <li><Link to="/job-requests">Job Requests</Link></li>
                            <li><Link to="/earnings">Earnings</Link></li>
                            <li><Link to="/profile">Profile</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Support</h4>
                        <ul>
                            <li><Link to="/">Help Center</Link></li>
                            <li><Link to="/">Safety Guidelines</Link></li>
                            <li><Link to="/">Partner Terms</Link></li>
                            <li><Link to="/">Contact Us</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Legal</h4>
                        <ul>
                            <li><Link to="/">Privacy Policy</Link></li>
                            <li><Link to="/">Terms of Service</Link></li>
                            <li><Link to="/">Cookie Policy</Link></li>
                            <li><Link to="/">Community Guidelines</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2024 SkillHive Partner Portal. All rights reserved.</p>
                    <div className="social-links">
                        <a href="#facebook" aria-label="Facebook"><FaFacebook /></a>
                        <a href="#twitter" aria-label="Twitter"><FaTwitter /></a>
                        <a href="#instagram" aria-label="Instagram"><FaInstagram /></a>
                        <a href="#linkedin" aria-label="LinkedIn"><FaLinkedin /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
